define('controllers/myreport/myreport-cloud-folder.ctrl',['app'], function (app) {
    app.controller('CFolderReport', ['$scope', '$q', 'OpenApp', 'OpenOther','reportUtil','auiDialog',
        function ($scope, $q, OpenApp, OpenOther,reportUtil,auiDialog) {
            /* 1. 局部变量声明 */
            var appList = [];
            var isAppIdOk = false;
            /* 2. $scope变量声明 */
            var Model = $scope.Model = {
                magicTypeClick:'line',
                magicTypePromote:'line',
                tabType: 'click',
                queryCFolderClick: {
                    // 这里可以什么都不写，直接用默认值
                    appId: ['-1'],                  //【产品下拉框】【默认值】-1
                    appListQueryMethod: $scope.$parent.initAppList('cFolder','3'),
                    regionShow: [0, 7, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 7,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    timeQuantum: 31,                 //【允许的时间跨度】默认值是不限制
                    //queryType:1,                    //【时间类型】【默认值】1【枚举】1:购买时间2:退款时间
                    //billTime:new Date(),            //【账单时间】【默认值】上个月
                    //status:-1,                      //【结算状态】【默认值】-1【枚举】-1:全部0:待确认1:已确认
                    //tradeId:'',                     //【订单编号】【默认值】空
                    //tradeStatus:-1,                 //【订单状态】【默认值】-1【枚举】-1:全部状态1:预扣2:确认扣除3:预扣解除4:直接扣除成功5:直接扣除失败6:退款成功
                    //sdkChannel:-1,                  //【推广渠道】【默认值】-1【枚举】-1:全部0:华为应用1:华为应用市场渠道2:预装渠道，3:游戏吧
                    //sdkChannelQueryType:"time",  //【查看方式】【默认值】time【枚举】time:日期app:应用payType:支付方式
                    queryMethod: queryCFolderClickList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadCFolderClickList, //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮
                    onload: init
                },
                queryCFolderPromote: {
                    // 这里可以什么都不写，直接用默认值
                    appId: '-2',                  //【产品下拉框】【默认值】-1
                    appListQueryMethod: getCFPAppList,//【产品下拉框查询方法】默认值是调用openDeveloper的GetProductList。 如果各个子页面不一样，可以定制
                    regionShow: [0, 7, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 7,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    timeQuantum: 180,
                    queryMethod: queryCFolderPromoteList, //【查询方法】必填。点击查询调用的方法
                    downloadMethod: downloadCFolderPromoteList //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮
                },
                paginationCFolderClick: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeCFolderClick
                },
                paginationCFolderPromote: {
                    currentPage: 1,
                    itemsPerPage: 10,
                    itemsPerPageBackUp: 10,
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,
                    onChange: pageChangeCFolderPromote
                },
                cFolderClickList: null,
                cFolderPromoteList: null,
                cFolderClickTotalDown: 0,
                cFolderPromoteTotalDown: 0,
                TotalconsumCountSum: 0,
                cFolderClickCharts: {
                    id: "myreport_cFolder_click",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                },
                cFolderPromoteCharts: {
                    id: "myreport_cFolder_promote",
                    width: "",//非必填参数
                    height: "400",
                    status: 1// 1: 初始化 2:加载完成
                }
            };
            $scope.appList = [];
            /* 3. $scope函数挂载 */
            $scope.changeTabType = changeTabType;
            $scope.queryCFolderClickList = queryCFolderClickList;
            $scope.downloadCFolderClickList = downloadCFolderClickList;

            $scope.queryCFolderPromoteList = queryCFolderPromoteList;
            $scope.downloadCFolderPromoteList = downloadCFolderPromoteList;

            /* 4. 初始化函数声明与执行 */
            function init() {
                changeTabType();
            }

            function queryCFolderPromoteList() {
                // 查询按钮，恢复筛选条件和排序规则
                var time = setInterval(function () {
                    if (isAppIdOk) {
                        queryAllList();
                        clearInterval(time);
                    }
                }, 100);
            }



            function getCFPAppList() {
                var defer = $q.defer();
                var cfpAppList = [];
                OpenOther.getCFAppTask({
                    startTime:AUI.DateUtil.date2Str(new Date()),
                    endTime:AUI.DateUtil.date2Str(new Date())
                }).then(function (data) {
                    if (data && data.CFAppTaskList) {
                        for (var i in data.CFAppTaskList) {
                            var appList = data.CFAppTaskList[i];
                            var appJson = {};
                            appJson.prodID = appList.taskId;
                            appJson.prodName = appList.taskName;
                            cfpAppList.push(appJson);
                        }
                    }
                    defer.resolve(cfpAppList);
                }).catch(function () {
                    defer.resolve(cfpAppList);
                }).finally(function(){
                    isAppIdOk = true;
                });
                return defer.promise;
            }

            function changeTabType(type) {
                if (type) {
                    Model.tabType = type;
                }
                switch (Model.tabType) {
                    case 'click':
                        if (Model.cFolderClickList == null) {
                            queryCFolderClickList();
                        }
                        break;
                    case 'promote':
                        if (Model.cFolderPromoteList == null) {
                            queryCFolderPromoteList();
                        }
                        break;
                }
            }

            /* 5. 函数声明 */
            function queryCFolderClickList() {
                var request = {
                    pageNum: 1,
                    pageSize: 100000
                };
                AUI.BaseJSUtil.mergeJSON(Model.queryCFolderClick, request);
                (request.appId == -1)?(delete request.appId):'';
                if(!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }
                OpenOther.getReportCfolderAppBI(request).then(function (resp) {
                    Model.cFolderClickList = resp.appClickRptList;
                    Model.cFolderClickTotalDown = resp.appDownCountSum;
                    Model.paginationCFolderClick.totalCount = resp.total;
                    Model.paginationCFolderClick.currentPage = 1;
                    Model.paginationCFolderClick.itemsPerPage = Model.paginationCFolderClick.itemsPerPageBackUp;
                }).catch(function () {
                    Model.cFolderClickList = [];
                    Model.cFolderClickTotalDown = 0;
                    Model.TotalconsumCountSum = 0;
                }).finally(function () {
                    getEchartConfig(Model.cFolderClickList);
                    pageChangeCFolderClick();
                });
            }

            function downloadCFolderClickList() {
                var request = {pageNum: 1, pageSize: 100000};
                AUI.BaseJSUtil.mergeJSON(Model.queryCFolderClick, request);
                if (request.appId == -1) {
                    delete request.appId;
                }
                if(!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return;
                }
                $scope.$parent.downloadReport(OpenOther.getCfolderDownloadReport, request, function (resp) {
                    return resp && AUI.BaseJSUtil.existy(resp.downUrl);
                });
            }

            function queryAllList() {
                if(getReportRequest()){
                    OpenOther.getCFAppTaskReport(getReportRequest()).then(function (resp) {
                        Model.paginationCFolderPromote.currentPage = 1;
                        Model.paginationCFolderPromote.itemsPerPage = Model.paginationCFolderPromote.itemsPerPageBackUp;
                        Model.cFolderPromoteList = resp.appClickRptList;
                        Model.cFolderPromoteTotalDown = resp.totalDownCountSum;
                        Model.TotalconsumCountSum = resp.totalconsumCountSum;
                        Model.paginationCFolderPromote.totalCount = resp.total;
                    }).catch(function () {
                        Model.cFolderPromoteList = [];
                        Model.cFolderPromoteTotalDown = 0;
                        Model.TotalconsumCountSum = 0;
                    }).finally(function () {
                        getEchartConfig2(Model.cFolderPromoteList);
                        pageChangeCFolderPromote();
                    });
                }

            }
            function formatCfData(appTaskList) {
                var retList = [];
                var retListObj = {};
                for (var index in appTaskList) {
                    var data = appTaskList[index];

                    if (retListObj[data.date]) {
                        var newDownCount = retListObj[data.date].downCount + data.downCount;
                        retListObj[data.date] = {
                            date: data.date,
                            downCount: newDownCount,
                        }

                    } else {
                        retListObj[data.date] = {
                            date: data.date,
                            downCount: data.downCount,
                        };
                    }
                }
                for (var dataRet in retListObj) {
                    retList.push(retListObj[dataRet]);
                }
                return retList;
            }
            function formatCfpData(appTaskList) {
                var retList = [];
                var retListObj = {};
                for (var index in appTaskList) {
                    var data = appTaskList[index];

                    if (retListObj[data.date]) {
                        var newDownCount = retListObj[data.date].downCount + data.downCount;
                        var newConsumeCount = retListObj[data.date].consumCount + data.consumCount;
                        retListObj[data.date] = {
                            date: data.date,
                            downCount: newDownCount,
                            consumCount:newConsumeCount
                        }

                    } else {
                        retListObj[data.date] = {
                            date: data.date,
                            downCount: data.downCount,
                            consumCount:data.consumCount
                        };
                    }
                }
                for (var dataRet in retListObj) {
                    retList.push(retListObj[dataRet]);
                }
                return retList;
            }

            function downloadCFolderPromoteList() {
                if(getReportRequest()){
                    $scope.$parent.downloadReport(OpenOther.exportReportCFPBI, getReportRequest(), function (resp) {
                        return resp && AUI.BaseJSUtil.existy(resp.downUrl);
                    });
                }

            }

            function getReportRequest() {
                var request = {
                    pageNum: 1,
                    pageSize: 100000
                };
                AUI.BaseJSUtil.mergeJSON(Model.queryCFolderPromote, request);
                request.taskList = request.appId;
                if (request.taskList == -1) {
                    delete request.taskList;
                }
                delete request.appId;
                if(!$scope.$parent.checkDate(request)) {
                    auiDialog.fail("时间区间选择错误","查询时间不得为空");
                    return false;
                }
                return request;
            }


            function getEchartConfig(dataList) {
                var result = reportUtil.getXYFromBI(formatCfData(dataList), "date", 1, ["downCount"]);
                Model.cFolderClickCharts.options = (result && result['date']&&result['date'].length > 0) ? {
                    legend: {
                        data: ['下载量']
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: result["date"]
                    }],
                    yAxis: [{ // 纵坐标
                        type: 'value'
                    }],
                    series: [{
                        "name": "下载量",
                        "type": Model.magicTypeClick,
                        "data": result["downCount"]
                    }]
                } : null;
            }

            function getEchartConfig2(dataList) {
                var result = reportUtil.getXYFromBI(formatCfpData(dataList), "date", 1, ["downCount","consumCount"]);
                Model.cFolderPromoteCharts.options = (result && result['date']&&result['date'].length > 0) ?{
                    legend: {
                        data: ['推广量','消耗量']
                    },
                    xAxis: [{ // 横坐标
                        type: 'category', data: result["date"]
                    }],
                    yAxis: [{ // 纵坐标
                        type: 'value'
                    }],
                    series: [{
                        "name": "推广量",
                        "type": Model.magicTypePromote,
                        "data": result["downCount"]
                    },{
                        "name": "消耗量",
                        "type": Model.magicTypePromote,
                        "data": result["consumCount"]
                    }]
                }:null;
            }

            /**
             * 这里做前台分页，不需要重新查询一次接口
             */
            function pageChangeCFolderClick() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.cFolderClickList, Model.paginationCFolderClick, true));
                Model.cFolderClickListForShow = result.listForShow;
            }

            function pageChangeCFolderPromote() {
                var result = {};
                $scope.$parent && (result = $scope.$parent.pagination(Model.cFolderPromoteList, Model.paginationCFolderPromote));
                Model.cFolderPromoteListForShow = result.listForShow;
            }

        }]
    );
});
